import { render, staticRenderFns } from "./trainingPlanGuide.vue?vue&type=template&id=4a96e62a&scoped=true"
import script from "./trainingPlanGuide.vue?vue&type=script&lang=js"
export * from "./trainingPlanGuide.vue?vue&type=script&lang=js"
import style0 from "./trainingPlanGuide.vue?vue&type=style&index=0&id=4a96e62a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a96e62a",
  null
  
)

export default component.exports